import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const PdfUploadIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="24" height="24" viewBox="0 0 400 400">
      <g>
        <g>
          <path
            className="st0"
            d="M271.5,328H106.3c-10,0-18.1-8.1-18.1-18V90c0-9.9,8.1-18,18.1-18h110.1c2.2,0,4,1.8,4,4v54.8
			c0,5.5,4.5,10,10.1,10h55c2.2,0,4,1.8,4,4v72c0,2.2-1.8,4-4,4H157.8c-5.5,0-10.1,4.5-10.1,10v48.4c0,5.5,4.5,10,10.1,10h127.7
			c2.2,0,4,1.8,4,4V310C289.5,319.9,281.4,328,271.5,328z M106.3,80c-5.5,0-10.1,4.5-10.1,10v220c0,5.5,4.5,10,10.1,10h165.2
			c5.5,0,10.1-4.5,10.1-10v-12.7H157.8c-10,0-18.1-8.1-18.1-18v-48.4c0-9.9,8.1-18,18.1-18h123.7v-64h-51c-10,0-18.1-8.1-18.1-18V80
			H106.3z"
          />
        </g>
        <g>
          <path
            className="st0"
            d="M285.5,148.8L285.5,148.8h-55c-10,0-18.1-8.1-18.1-18V76c0-1.6,1-3.1,2.5-3.7s3.2-0.3,4.4,0.9l68.9,68.6
			c0.9,0.7,1.4,1.8,1.4,3.1C289.5,147,287.7,148.8,285.5,148.8z M220.4,85.6v45.2c0,5.5,4.5,10,10.1,10h45.3L220.4,85.6z"
          />
        </g>
        <g>
          <path
            className="st0"
            d="M293.7,297.3H157.8c-10,0-18.1-8.1-18.1-18v-48.4c0-9.9,8.1-18,18.1-18h135.9c10,0,18.1,8.1,18.1,18v48.4
			C311.8,289.2,303.7,297.3,293.7,297.3z M157.8,220.9c-5.5,0-10.1,4.5-10.1,10v48.4c0,5.5,4.5,10,10.1,10h135.9
			c5.5,0,10.1-4.5,10.1-10v-48.4c0-5.5-4.5-10-10.1-10H157.8z"
          />
        </g>
        <g>
          <path
            className="st1"
            d="M173.4,280.1c-2.2,0-4-1.8-4-4V240c0-2.2,1.8-4,4-4h15.4c6.3,0,10.8,5.8,10.8,13.9c0,8.1-4.6,13.9-10.8,13.9
			h-11.4v12.4C177.4,278.4,175.7,280.1,173.4,280.1z M177.4,255.7h11.4c0.3,0,1,0,1.7-1.2c0.7-1.1,1.1-2.9,1.1-4.7
			c0-2.8-1.1-5.9-2.8-5.9h-11.4V255.7z"
          />
        </g>
        <g>
          <g>
            <path
              className="st1"
              d="M229.4,280.1H214c-2.2,0-4-1.8-4-4V240c0-2.2,1.8-4,4-4h15.4c9.6,0,16.3,9.1,16.3,22.1
				c0,5.5-1.3,10.6-3.7,14.5C239,277.5,234.6,280.1,229.4,280.1z M217.9,272.1h11.4c2.4,0,4.3-1.2,5.8-3.7c1.6-2.6,2.5-6.4,2.5-10.4
				c0-5.7-2.2-14.1-8.3-14.1h-11.4V272.1z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              className="st1"
              d="M260,280.1c-2.2,0-4-1.8-4-4V240c0-2.2,1.8-4,4-4h22c2.2,0,4,1.8,4,4s-1.8,4-4,4h-18v32.2
				C264,278.4,262.2,280.1,260,280.1z"
            />
          </g>
          <g>
            <path
              className="st1"
              d="M275.3,260.3H260c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4h15.2c2.2,0,4,1.8,4,4
				C279.3,258.5,277.5,260.3,275.3,260.3z"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

// <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
// 	 viewBox="0 0 400 400" style="enable-background:new 0 0 400 400;" xml:space="preserve">
// <style type="text/css">
// 	.st0{fill:#1D2848;stroke:#1D2848;stroke-width:4;stroke-miterlimit:10;}
// 	.st1{fill:#1D2848;stroke:#1D2848;stroke-width:2;stroke-miterlimit:10;}
// </style>
// <g>
// 	<g>
// 		<path class="st0" d="M271.5,328H106.3c-10,0-18.1-8.1-18.1-18V90c0-9.9,8.1-18,18.1-18h110.1c2.2,0,4,1.8,4,4v54.8
// 			c0,5.5,4.5,10,10.1,10h55c2.2,0,4,1.8,4,4v72c0,2.2-1.8,4-4,4H157.8c-5.5,0-10.1,4.5-10.1,10v48.4c0,5.5,4.5,10,10.1,10h127.7
// 			c2.2,0,4,1.8,4,4V310C289.5,319.9,281.4,328,271.5,328z M106.3,80c-5.5,0-10.1,4.5-10.1,10v220c0,5.5,4.5,10,10.1,10h165.2
// 			c5.5,0,10.1-4.5,10.1-10v-12.7H157.8c-10,0-18.1-8.1-18.1-18v-48.4c0-9.9,8.1-18,18.1-18h123.7v-64h-51c-10,0-18.1-8.1-18.1-18V80
// 			H106.3z"/>
// 	</g>
// 	<g>
// 		<path class="st0" d="M285.5,148.8L285.5,148.8h-55c-10,0-18.1-8.1-18.1-18V76c0-1.6,1-3.1,2.5-3.7s3.2-0.3,4.4,0.9l68.9,68.6
// 			c0.9,0.7,1.4,1.8,1.4,3.1C289.5,147,287.7,148.8,285.5,148.8z M220.4,85.6v45.2c0,5.5,4.5,10,10.1,10h45.3L220.4,85.6z"/>
// 	</g>
// 	<g>
// 		<path class="st0" d="M293.7,297.3H157.8c-10,0-18.1-8.1-18.1-18v-48.4c0-9.9,8.1-18,18.1-18h135.9c10,0,18.1,8.1,18.1,18v48.4
// 			C311.8,289.2,303.7,297.3,293.7,297.3z M157.8,220.9c-5.5,0-10.1,4.5-10.1,10v48.4c0,5.5,4.5,10,10.1,10h135.9
// 			c5.5,0,10.1-4.5,10.1-10v-48.4c0-5.5-4.5-10-10.1-10H157.8z"/>
// 	</g>
// 	<g>
// 		<path class="st1" d="M173.4,280.1c-2.2,0-4-1.8-4-4V240c0-2.2,1.8-4,4-4h15.4c6.3,0,10.8,5.8,10.8,13.9c0,8.1-4.6,13.9-10.8,13.9
// 			h-11.4v12.4C177.4,278.4,175.7,280.1,173.4,280.1z M177.4,255.7h11.4c0.3,0,1,0,1.7-1.2c0.7-1.1,1.1-2.9,1.1-4.7
// 			c0-2.8-1.1-5.9-2.8-5.9h-11.4V255.7z"/>
// 	</g>
// 	<g>
// 		<g>
// 			<path class="st1" d="M229.4,280.1H214c-2.2,0-4-1.8-4-4V240c0-2.2,1.8-4,4-4h15.4c9.6,0,16.3,9.1,16.3,22.1
// 				c0,5.5-1.3,10.6-3.7,14.5C239,277.5,234.6,280.1,229.4,280.1z M217.9,272.1h11.4c2.4,0,4.3-1.2,5.8-3.7c1.6-2.6,2.5-6.4,2.5-10.4
// 				c0-5.7-2.2-14.1-8.3-14.1h-11.4V272.1z"/>
// 		</g>
// 	</g>
// 	<g>
// 		<g>
// 			<path class="st1" d="M260,280.1c-2.2,0-4-1.8-4-4V240c0-2.2,1.8-4,4-4h22c2.2,0,4,1.8,4,4s-1.8,4-4,4h-18v32.2
// 				C264,278.4,262.2,280.1,260,280.1z"/>
// 		</g>
// 		<g>
// 			<path class="st1" d="M275.3,260.3H260c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4h15.2c2.2,0,4,1.8,4,4
// 				C279.3,258.5,277.5,260.3,275.3,260.3z"/>
// 		</g>
// 	</g>
// </g>
// </svg>
